import React from 'react';
import MinimalLayout from 'signer-app/parts/minimal-layout';
import { getWebflowUrl } from 'signer-app/utils/url-helpers';
import { useIntl } from 'react-intl';
import { EidWidget } from './eid-widget';
import { useLocation } from 'react-router-dom';
import { Box } from '@dropbox/dig-foundations';
import invariant from 'invariant';

export function EidComplete() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const intl = useIntl();

  const qesUrl = searchParams.get('qesUrl');
  const clientId = searchParams.get('clientId');
  const countryCode = searchParams.get('countryCode') || undefined;
  const hasAdditionalSigningMethods =
    searchParams.get('hasAdditionalSigningMethods') === '1';

  invariant(
    qesUrl && clientId,
    'EidCompleteRoute requires qesUrl and clientId query parameters',
  );

  return (
    <MinimalLayout
      locale={intl.locale}
      siteCode="S"
      contentCentered
      logoHref={getWebflowUrl('', 'S')}
      variant="900"
    >
      <Box
        display="flex"
        flexDirection="column"
        padding="Macro Small"
        alignItems="center"
        width="100%"
        marginX="auto"
        style={{ maxWidth: '600px' }}
      >
        <EidWidget
          qesUrl={qesUrl}
          clientId={clientId}
          countryCode={countryCode}
          hasAdditionalSigningMethods={hasAdditionalSigningMethods}
        />
      </Box>
    </MinimalLayout>
  );
}
